// src/pages/ThankYou.js
import React from 'react';
import { Link } from 'react-router-dom';

const ThankYou = () => {
  return (
    <div style={{ padding: '60px', textAlign: 'center' }}>
      <h1>Thank You!</h1>
      <p>Your message has been submitted successfully. We'll be in touch shortly.</p>
      <Link to="/" style={{ textDecoration: 'underline', color: '#007bff' }}>
        Back to Home
      </Link>
    </div>
  );
};

export default ThankYou;
